import axios from 'axios'
import GroupsApi from './Groups'

const controller = new window.AbortController()
const axiosHelpers = require('axios-helpers');
let api = axiosHelpers(axios.create({
    baseURL: 'https://exporter-api.hexeko.com/api/v1',
    crossdomain: true,
    timeout: 100000,
    signal: controller.signal,
}));

api.groups = GroupsApi;

export default api
